export default {"src":"/uk/_next/static/media/spot-phone.6e0137ad.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};